import React from "react";
import { Icon } from "@blasterjs/core";
import { useQuery } from "react-query";

import { Campaign } from "datamodel/campaign";
import fetchRandomTask from "pages/helpers/fetchRandomTask";
import { TaskURLActionType } from "types";
import AccessLimiter from "components/AccessControl/AccessLimiter";
import { ACRActionType } from "datamodel/permissions";
import AccessControlProvider from "components/AccessControl/AccessControlProvider";
import GButton, { GButtonProps } from "components/GButton";
import { isNone } from "fp-ts/es6/Option";
import { useHistory } from "react-router";
import { foldOption, noop } from "lib";
import urlForRandomTask from "pages/helpers/urlForRandomTask";
import { queryClient } from "App";

type Props = {
  campaign: Campaign;
} & Omit<GButtonProps, "children">;

const LabelButton = ({ campaign, ...rest }: Props) => {
  const history = useHistory();
  const { data: nextTaskOption } = useQuery(
    ["campaign-label-next"],
    () =>
      fetchRandomTask(TaskURLActionType.Label, {
        campaignId: campaign.id,
      }),
    {
      cacheTime: 0,
      refetchInterval: 30000,
      onSuccess: (taskOption) => {
        foldOption(taskOption, noop, (task) => {
          queryClient.setQueryData(["task", task.id], task);
        });
      },
    }
  );

  const onClick = () => {
    nextTaskOption &&
      foldOption(nextTaskOption, noop, (task) =>
        history.push(
          urlForRandomTask(task.properties.projectId, task.id, TaskURLActionType.Label, {
            campaignId: campaign.id,
          })
        )
      );
  };

  return (
    <AccessControlProvider campaignId={campaign.id}>
      <AccessLimiter requiredActions={[[ACRActionType.Annotate]]}>
        <GButton
          data-intercom-target="label-button"
          colorScheme="#ffffff"
          ml={1}
          disabled={!nextTaskOption || isNone(nextTaskOption)}
          onClick={onClick}
          {...rest}
        >
          <Icon name="drawPolygon" mr={1} />
          Label
        </GButton>
      </AccessLimiter>
    </AccessControlProvider>
  );
};

export default LabelButton;
